import { MainContainer } from "@/appComponents/Blocks/Utils/MainContainer";
import Header from "@/appComponents/Navigation/Header/Header";
import { MainToolbarDirectoryTabular } from "@/appComponents/Navigation/MainToolbar/MainToolbarDirectory";
import { DataTable, Loader } from "@theorgchartdev/storybook";
import { useDirectoryTabularContext } from "@/providers/DirectoryTabularProvider";
import { useModalContainerHeight } from "@/hooks/useModalContainerHeight";
import { appstr } from "@coreapp/utils/appstr";

const DirectoryTabularPage = () => {
  const { isFetching, isSearchLoading, tableRef } = useDirectoryTabularContext();

  const containerHeight = useModalContainerHeight();

  const showLoader = isFetching || isSearchLoading;

  return (
    <>
      <div className="appHeader">
        <Header />
        <div className="mainToolBar">
          <MainToolbarDirectoryTabular />
        </div>
      </div>
      <MainContainer>
        <Loader.Root asChild>
          <div
            data-testid="directory-table-container"
            className="oc-table-container"
            style={{ height: containerHeight }}
          >
            <DataTable.Root ref={tableRef} caption={appstr("Directory")}>
              <DataTable.Header />
              <DataTable.Body />
            </DataTable.Root>
            <DataTable.Pagination pageSizeOptions={[25, 50, 100]} />
            {showLoader && (
              <Loader.Container>
                <Loader.Spinner />
                <Loader.Text>{appstr("Loading")}</Loader.Text>
              </Loader.Container>
            )}
          </div>
        </Loader.Root>
      </MainContainer>
    </>
  );
};

export default DirectoryTabularPage;
